<ng-container *ngIf="!sending">
	<div class="tb-controls-wrapper">
		<div class="tb-controls-panel">
			<div class="tb-panel__row tb-panel__row--primary">
				<div class="tb-panel__exports" aria-label="Export">
					<button type="button" class="btn btn-success btn-sm" (click)="exportXls();" title="Excel"><i class="fa fa-file-excel-o"></i></button>
					<a href="{{this.arlink.apiServer.baseUrl}}{{this.arlink.apiServer.arTrialLink}}{{summary_details.value}}" class="btn btn-danger btn-sm" title="PDF"><i class="fa fa-file-pdf-o"></i></a>
				</div>
				<div class="tb-panel__primary-tools">
					<mat-form-field appearance="outline" class="tb-field tb-field--view">
						<mat-label>View</mat-label>
						<mat-select [formControl]="summary_details">
							<mat-option *ngFor="let k of summary_or_details" [value]="k.value">
								{{ k.label }}
							</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-form-field appearance="outline" class="tb-field tb-field--search">
						<mat-label>Search</mat-label>
						<input matInput type="search" autocomplete="off" [(ngModel)]="toolbarSearchText" (ngModelChange)="onToolbarSearchChange()" placeholder="Name, #, terms…" />
					</mat-form-field>
					<button *ngIf="showToolbarRefresh" mat-stroked-button color="primary" type="button" class="tb-btn-refresh"
						[disabled]="toolbarRefreshDisabled"
						(click)="emitToolbarRefresh()">
						<mat-icon>refresh</mat-icon>
						Refresh
					</button>
				</div>
			</div>
			<div class="tb-panel__row tb-panel__row--filters">
				<mat-form-field appearance="outline" class="tb-field tb-field--filter">
					<mat-label>Salesman</mat-label>
					<mat-select multiple [(ngModel)]="filterSalesmanCodes" (selectionChange)="applyFilters()" placeholder="All">
						<mat-option *ngFor="let s of salesmanOptions" [value]="s.code">{{ s.name }}<span *ngIf="s.name !== s.code"> ({{ s.code }})</span></mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline" class="tb-field tb-field--filter">
					<mat-label>Terms</mat-label>
					<mat-select multiple [(ngModel)]="filterTermsCodes" (selectionChange)="applyFilters()" placeholder="All">
						<mat-option *ngFor="let t of termsOptions" [value]="t.code">{{ t.label }}<span *ngIf="t.label !== t.code"> ({{ t.code }})</span></mat-option>
					</mat-select>
				</mat-form-field>
				<mat-form-field appearance="outline" class="tb-field tb-field--filter">
					<mat-label>Card on file</mat-label>
					<mat-select [(ngModel)]="cardOnFileFilter" (selectionChange)="applyFilters()">
						<mat-option value="all">All</mat-option>
						<mat-option value="yes">Yes</mat-option>
						<mat-option value="no">No</mat-option>
					</mat-select>
				</mat-form-field>
				<div class="tb-field tb-field--toggle" title="Show rows with negative AR balance">
					<span class="tb-field__toggle-label">Neg. balance</span>
					<div class="tb-toggle-row">
						<span class="tb-toggle-side" [class.active]="!includeNegativeBalances">Hide</span>
						<mat-slide-toggle [(ngModel)]="includeNegativeBalances" (ngModelChange)="applyFilters()" color="primary"></mat-slide-toggle>
						<span class="tb-toggle-side" [class.active]="includeNegativeBalances">Show</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
<div class="listitem row border-bottom pl-1 pr-1 ml-1 mr-1">
	<ng-container *ngIf="sending">
		<svg class="spinner" width="30px" height="30px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
			<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
		</svg>
	</ng-container>
	<div class="table">
		<ng-container>
			<div class="table table-fluid w-100" #printTable>
			  <table class="table table-fluid w-100">
				<thead class="thead-dark">
				  <tr>
					<th class="sticky-header tb-sortable" scope="col" (click)="setSort('name')" [attr.aria-sort]="sortIndicator('name') === 'asc' ? 'ascending' : (sortIndicator('name') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Name</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('name') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable" scope="col" (click)="setSort('debtorno')" [attr.aria-sort]="sortIndicator('debtorno') === 'asc' ? 'ascending' : (sortIndicator('debtorno') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Customer #</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('debtorno') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th *ngIf="showAccountOverviewAction" class="sticky-header text-center tb-col-overview donotprint" scope="col">Account</th>
					<th *ngIf="showPaymentAction" class="sticky-header text-center tb-col-pay donotprint" scope="col">Pay</th>
					<th class="sticky-header tb-sortable" scope="col" (click)="setSort('typename')" [attr.aria-sort]="sortIndicator('typename') === 'asc' ? 'ascending' : (sortIndicator('typename') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Customer Type</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('typename') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable" scope="col" (click)="setSort('terms')" [attr.aria-sort]="sortIndicator('terms') === 'asc' ? 'ascending' : (sortIndicator('terms') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Terms</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('terms') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable" scope="col" (click)="setSort('salesperson')" [attr.aria-sort]="sortIndicator('salesperson') === 'asc' ? 'ascending' : (sortIndicator('salesperson') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Salesperson</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('salesperson') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header text-center tb-sortable" scope="col" (click)="setSort('card_on_file')" [attr.aria-sort]="sortIndicator('card_on_file') === 'asc' ? 'ascending' : (sortIndicator('card_on_file') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Card on file</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('card_on_file') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('creditlimit')" [attr.aria-sort]="sortIndicator('creditlimit') === 'asc' ? 'ascending' : (sortIndicator('creditlimit') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Credit</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('creditlimit') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable" scope="col" (click)="setSort('reasondescription')" [attr.aria-sort]="sortIndicator('reasondescription') === 'asc' ? 'ascending' : (sortIndicator('reasondescription') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Status</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('reasondescription') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('balance')" [attr.aria-sort]="sortIndicator('balance') === 'asc' ? 'ascending' : (sortIndicator('balance') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Balance</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('balance') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('future')" [attr.aria-sort]="sortIndicator('future') === 'asc' ? 'ascending' : (sortIndicator('future') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Future</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('future') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('current')" [attr.aria-sort]="sortIndicator('current') === 'asc' ? 'ascending' : (sortIndicator('current') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">Current</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('current') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('due')" [attr.aria-sort]="sortIndicator('due') === 'asc' ? 'ascending' : (sortIndicator('due') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">30 Day</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('due') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('overdue')" [attr.aria-sort]="sortIndicator('overdue') === 'asc' ? 'ascending' : (sortIndicator('overdue') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">60 Day</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('overdue') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('overdue1')" [attr.aria-sort]="sortIndicator('overdue1') === 'asc' ? 'ascending' : (sortIndicator('overdue1') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">90 Day</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('overdue1') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
					<th class="sticky-header tb-sortable text-right" scope="col" (click)="setSort('overdue2')" [attr.aria-sort]="sortIndicator('overdue2') === 'asc' ? 'ascending' : (sortIndicator('overdue2') === 'desc' ? 'descending' : 'none')">
						<span class="tb-th-label">120 Day</span>
						<mat-icon class="tb-sort-icon" *ngIf="sortIndicator('overdue2') as dir">{{ dir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
					</th>
				  </tr>
				</thead>
				<tbody>
				  <ng-container *ngFor="let result of gridRows; let i = index">
					<tr>
					  <td>{{ result.name }}</td>
					  <td><a [routerLink]="'/customers/view/'+result.debtorno">{{ result.debtorno }}</a></td>
					  <td *ngIf="showAccountOverviewAction" class="text-center tb-col-overview donotprint">
						<button type="button" mat-icon-button (click)="emitAccountOverview(result, $event)"
							matTooltip="Balance, saved cards, open AR">
							<mat-icon>account_balance_wallet</mat-icon>
						</button>
					  </td>
					  <td *ngIf="showPaymentAction" class="text-center tb-col-pay donotprint">
						<button type="button" mat-icon-button color="primary" (click)="emitTakePayment(result, $event)"
							matTooltip="Take payment">
							<mat-icon>payment</mat-icon>
						</button>
					  </td>
					  <td>{{ result.typename }}</td>
					  <td>{{ result.terms }}</td>
					  <td>{{ salespersonDisplay(result) }}</td>
					  <td class="text-center text-nowrap">{{ result.card_on_file || '—' }}</td>
					  <td>{{ result.creditlimit | currency }}</td>
					  <td>{{ result.reasondescription }}</td>
					  <td class="text-right">{{ result.balance | currency }}</td>
					  <td class="text-right">{{ result.future | currency }}</td>
					  <td class="text-right">{{ result.current | currency }}</td>
					  <td class="text-right">{{ result.due | currency }}</td>
					  <td class="text-right">{{ result.overdue | currency }}</td>
					  <td class="text-right">{{ result.overdue1 | currency }}</td>
					  <td class="text-right">{{ result.overdue2 | currency }}</td>
					</tr>
					<ng-container *ngIf="!summary_details.value && result.details">
					  <tr>
						<td [attr.colspan]="trialBalanceColCount" class="p-0">
						  <div class="card mb-3 ">
							<div class="card-header donotprint">
							  <strong>Details for {{ result.name }}</strong>
							</div>
							<div class="card-body p-0">
							  <table class="table table-bordered table-striped table-hover mb-0">
								<thead class="thead-light">
								  <tr>
									<th></th>
									<th>Type</th>
									<th>Invoice#</th>
									<th>Order#</th>
									<th>Date</th>
									<th>Terms</th>
									<th class="text-right">Balance</th>
									<th class="text-right">Future</th>
									<th class="text-right">Current</th>
									<th class="text-right">30 Day</th>
									<th class="text-right">60 Day</th>
									<th class="text-right">90 Day</th>
									<th class="text-right">120 Day</th>
								  </tr>
								</thead>
								<tbody>
									<ng-container *ngFor="let det of result.details; let b = index">
								  <tr *ngIf="det.name">
										<th></th>
										<td>{{ det.typename }}</td>
										<td>{{ det.transno }}</td>
										<td>{{ det.order_ }}</td>
										<td>{{ det.transdate | date:'short' }}</td>
										<td>{{ det.payterms }}</td>
										<td class="text-right">{{ det.balance | currency }}</td>
										<td class="text-right">{{ det.future | currency }}</td>
										<td class="text-right">{{ det.current | currency }}</td>
										<td class="text-right">{{ det.due | currency }}</td>
										<td class="text-right">{{ det.overdue | currency }}</td>
										<td class="text-right">{{ det.overdue1 | currency }}</td>
										<td class="text-right">{{ det.overdue2 | currency }}</td>

								  </tr>
								  </ng-container>
								</tbody>
							  </table>
							</div>
						  </div>
						</td>
					  </tr>
					</ng-container>
				  </ng-container>
				  <tr>
					<td>TOTAL</td>
					<td></td>
					<td *ngIf="showAccountOverviewAction"></td>
					<td *ngIf="showPaymentAction"></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td class="text-right">{{ total_balance | currency }}</td>
					<td class="text-right">{{ total_future | currency }}</td>
					<td class="text-right">{{ total_current | currency }}</td>
					<td class="text-right">{{ total_due | currency }}</td>
					<td class="text-right">{{ total_overdue | currency }}</td>
					<td class="text-right">{{ total_overdue1 | currency }}</td>
					<td class="text-right">{{ total_overdue2 | currency }}</td>
				  </tr>
				</tbody>
			  </table>
			</div>


			<ng-container *ngIf="paginator_show">
				<mat-paginator [pageSizeOptions]="[2000,3000]" showFirstLastButtons aria-label="select page" [hidePageSize]="paginator_show" [pageSize]="pageSize">
				</mat-paginator>
			</ng-container>
		</ng-container>
	</div>
</div>
